import { faker } from '@faker-js/faker'

import { HospitalCountry } from '../../contracts/hospital'
import { UserServiceOfferHospital } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getUserServiceOfferHospital = asBuilder((): UserServiceOfferHospital => {
  return {
    id: faker.number.int(),
    name: faker.string.uuid(),
    phoneNumber: faker.phone.number(),

    customersPick: faker.datatype.boolean(),
    cctvInstalled: faker.datatype.boolean(),

    country: faker.helpers.enumValue(HospitalCountry),
    location: {
      latitude: faker.location.latitude(),
      longitude: faker.location.longitude(),
      district: faker.string.uuid(),
      addresses: faker.helpers.multiple(() => ({
        language: faker.helpers.arrayElement(['ko', 'ja']),
        address: faker.string.uuid(),
      })),
    },
  }
})
